export const SEBASTIAN_CMA_FORM_VERSION = 'sebastian_cma';

const zillow360Copy = {
    formHeader: 'Learn more about Zillow 360',
    formBody: 'A Zillow Advisor will contact you to talk more about your potential savings.',
    successTitle: 'Thanks for contacting us about Zillow 360!',
    successBody:
        'A Zillow Advisor will contact you soon to learn more about your needs and help determine your best options to save.',
};

const estimatedSalePriceCopy = {
    formHeader: 'How can we reach you?',
    formBody:
        'Discuss your unique situation and walk through all your options with a Zillow Advisor.',
    successTitle: 'Thanks for contacting us!',
    successBody:
        'We’ll be in touch soon to discuss your selling needs and how to get the most out of your home sale.',
};

const cmaCopy = {
    formHeader: 'How can we reach you?',
    formBody:
        'A Zillow Advisor will connect you with a local agent to discuss your home condition and provide a detailed estimate of your sale price.',
    successTitle: 'Thanks for contacting us!',
    successBody:
        'We’ll be in touch soon to discuss your selling needs and how to get the most out of your home sale.',
};

export function getCopy(contactFormVersion: string | undefined, location: string): string {
    switch (contactFormVersion) {
        case 'sebastian-360':
            return zillow360Copy[location] as string;
        case SEBASTIAN_CMA_FORM_VERSION:
            return cmaCopy[location] as string;
        case 'estimated-sale-price':
        default:
            return estimatedSalePriceCopy[location] as string;
    }
}
